import helpers from 'helpers'

const diffAndBuildPayload = (data, snap, columns, roles) => {
  const { KANBAN_COLUMN_ROLE_FINALIZED } = roles

  const currentResponsibles = (data.responsibleIds || [])
    .map((user) => user.id)
    .sort()
    .join(',')
  const currentDepartments = (data.departmentIds || [])
    .map((department) => department.id)
    .sort()
    .join(',')

  if (snap) {
    const unchanged =
      data.name === snap.name &&
      data.reason === snap.reason &&
      data.description === snap.description &&
      data.priority === snap.priority &&
      data.kanbanColumnId === snap.kanbanColumnId &&
      currentDepartments === snap.departmentIds &&
      helpers.formatters.toISOStringVerify(data.dueDate) === snap.dueDate &&
      currentResponsibles === snap.responsibleIds &&
      !data.attachments
    if (unchanged) return { unchanged: true, payload: null }
  }

  const nonStatusFieldChanged = snap
    ? data.name !== snap.name ||
      data.reason !== snap.reason ||
      data.description !== snap.description ||
      data.priority !== snap.priority ||
      currentDepartments !== snap.departmentIds ||
      helpers.formatters.toISOStringVerify(data.dueDate) !== snap.dueDate ||
      currentResponsibles !== snap.responsibleIds ||
      !!data.attachments
    : false

  const newFiles = data.attachments
    ? Array.from(data.attachments).filter((file) => file instanceof File)
    : []
  const selectedColumn = columns.find(
    (column) => column.id === data.kanbanColumnId,
  )
  const columnChanged = !!snap && data.kanbanColumnId !== snap.kanbanColumnId
  const payload = {
    ...data,
    responsibleIds: data.responsibleIds?.map((user) => user.id) || [],
    departmentIds: (data.departmentIds || []).map(
      (department) => department.id,
    ),
    dueDate: helpers.formatters.toISOStringVerify(data?.dueDate),
    attachments: newFiles.length ? newFiles : null,
    isFinalize: selectedColumn?.role === KANBAN_COLUMN_ROLE_FINALIZED,
    isMoveColumn:
      columnChanged && selectedColumn?.role !== KANBAN_COLUMN_ROLE_FINALIZED,
    overrideFields: nonStatusFieldChanged,
  }

  return { unchanged: false, payload, nonStatusFieldChanged }
}

export default diffAndBuildPayload
